<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:13:59
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-08 19:18:59
-->
<template>
  <a-card class="certified-box">
    <p class="title">认证商城</p>
    <a-select class="input-style" size="large" v-model:value="params.shopType"
     placeholder="请选择主体类型">
      <a-select-option v-for="item in shopCompanyList" :key="item.code" :value="item.code">
        {{item.name}}
      </a-select-option>
    </a-select>
    <a-select class="input-style" mode="multiple" v-model:value="params.mainCategory"
    size="large" placeholder="请选择经营类目（最多任选5个）">
      <a-select-option v-for="item in shopMainCatList" :key="item.code" :value="item.code">
        {{ item.name }}
      </a-select-option>
    </a-select>
    <p class="small-title">营业执照</p>
    <div class="photo-box">
      <a-upload
        v-model:file-list="fileList"
        name="qualificationPhotos"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.qualificationPhotos"
        :src="params.qualificationPhotos" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">
            <p>点击上传</p>
            <p>营业执照</p>
          </div>
        </div>
      </a-upload>
    </div>
    <p class="small-title">法人证件照</p>
    <div class="photo-box">
      <a-upload
        v-model:file-list="fileList"
        name="idCardFont"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.idCardFont"
        :src="params.idCardFont" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">
            <p>点击上传</p>
            <p>证件照正面</p>
          </div>
        </div>
      </a-upload>
      <a-upload
        v-model:file-list="fileList"
        name="idCardBack"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.idCardBack"
        :src="params.idCardBack" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">
            <p>点击上传</p>
            <p>证件照反面</p>
          </div>
        </div>
      </a-upload>
      <!-- <a-upload
        v-model:file-list="fileList"
        name="idCardHand"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.idCardHand"
        :src="params.idCardHand" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">点击上传法人手持证件照</div>
        </div>
      </a-upload> -->
    </div>
    <p class="small-title">门店照片/网上商城截图</p>
    <div class="photo-box">
      <a-upload
        v-model:file-list="fileList"
        name="shopFont"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.shopFont"
        :src="params.shopFont" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">
            <p>点击上传</p>
            <p>门店门头照片</p>
            <p>或网上商城首页截图</p>
          </div>
        </div>
      </a-upload>
      <a-upload
        v-model:file-list="fileList"
        name="shopInside"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.shopInside"
        :src="params.shopInside" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">
            <p>点击上传</p>
            <p>门店内景照片</p>
            <p>或网上商城商品详情截图</p>
          </div>
        </div>
      </a-upload>
      <a-upload
        v-model:file-list="fileList"
        name="shopPrice"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :customRequest="uploadImg"
      >
        <img style="width: 100%;" v-if="params.shopPrice"
        :src="params.shopPrice" alt="avatar" />
        <div v-else>
          <div class="ant-upload-text">
            <p>点击上传</p>
            <p>门店收银台照片</p>
            <p>或网上商城管理后台截图</p>
          </div>
        </div>
      </a-upload>
    </div>
    <a-button type="primary" class="accept-btn" @click="supplementShop()">提交认证</a-button>
  </a-card>
</template>

<script lang="ts">
import { computed, ref, defineComponent } from 'vue';
import commonApi from '@/api/common';
import jsonApi from '@/api/json';
import environment from '@/untils/environment';
import { message as $message } from 'ant-design-vue';

const OPTIONS = ['Apples', 'Nails', 'Bananas', 'Helicopters'];

const Parm: {
  [x: string]: string | number | null | [];
} = {
  shopType: null,
  mainCategory: [],
  qualificationPhotos: '',
  idCardFont: '',
  idCardBack: '',
  idCardHand: '',
  shopFont: '',
  shopInside: '',
  shopPrice: '',
};

export default defineComponent({
  name: 'CertifiedShop',
  setup() {
    const selectedItems = ref<string[]>([]);

    const filteredOptions = computed(() => OPTIONS.filter((o) => !selectedItems.value.includes(o)));

    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };

    return {
      selectedItems,
      filteredOptions,
      error,
      success,
    };
  },
  components: {
  },
  data() {
    return {
      shopCompanyList: [],
      shopMainCatList: [],
      environ: environment,
      params: Parm,
    };
  },
  mounted() {
    this.getJson();
  },
  methods: {
    getJson() {
      jsonApi.shopCompanyType().then((data: Record<string, object>) => {
        Object.keys(data).forEach((key) => {
          console.log(key);
          this.shopCompanyList.push(data[key] as never);
        });
        console.log(this.shopCompanyList);
      });
      jsonApi.shopMainGoods().then((data: Record<string, object>) => {
        Object.keys(data).forEach((key) => {
          console.log(key);
          this.shopMainCatList.push(data[key] as never);
        });
        console.log(this.shopMainCatList);
      });
    },
    uploadImg(files: {
      filename: string;
      file: {};
      }) {
      console.log(files);
      const formdata = new FormData();
      const file = files.file as unknown as Blob;
      formdata.append('files', file);
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.uploadImg(formdata).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          const key = files.filename;
          console.log(key);
          this.params[key] = data.url;
          console.log(this.params);
        } else {
          this.error(message);
          console.log(message);
        }
      });
    },
    supplementShop() {
      console.log(this.params);
      if (!this.params.shopType) {
        this.error('请选择主体类型');
        return;
      }
      const mainCategory = this.params.mainCategory as string[];
      if (mainCategory.length === 0 || mainCategory.length > 5) {
        this.error('经营类目至少选择1个,最多选择5个');
        return;
      }
      if (!this.params.qualificationPhotos) {
        this.error('请上传社会信用代码证');
        return;
      }
      if (!this.params.idCardFont) {
        this.error('请上传证件照正面');
        return;
      }
      if (!this.params.idCardBack) {
        this.error('请上传证件照背面');
        return;
      }
      // if (!this.params.idCardHand) {
      //   this.error('请上传法人手持证件照');
      //   return;
      // }
      if (!this.params.shopFont) {
        this.error('请上传门店头照片');
        return;
      }
      if (!this.params.shopInside) {
        this.error('请上传门店内景照片');
        return;
      }
      if (!this.params.shopPrice) {
        this.error('请上传门店收银台照片');
        return;
      }
      interface Data{
        data: Shopinfo;
        success: boolean;
        message: string;
      }
      interface Shopinfo{
        shopName: string;
        shopVerifySubmitStatus: number;
      }

      const main = mainCategory ? mainCategory.join(',') : '';
      const param = {
        extendMap: {
          shopType: this.params.shopType,
          mainCategory: main,
          qualificationPhotos: this.params.qualificationPhotos,
          idCardPhotos: `${this.params.idCardFont},${this.params.idCardBack},${this.params.idCardHand}`,
          shopPhotos: `${this.params.shopFont},${this.params.shopInside},${this.params.shopPrice}`,
        },
      };
      console.log(param);
      commonApi.submitShopVerify(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          const parent = this.$parent as unknown as {[x: string]: Function};
          parent.nextAuthenticationStatus(1);
        } else {
          this.error(message);
          console.log(message);
        }
      });
    },
  },
});
</script>
<style lang="stylus" scoped>
    ::v-deep .ant-upload.ant-upload-select-picture-card
      background #fff
      width 164px
      height 100px
      border 1px solid #D5D5D5
      color #999
    .certified-box
      margin 0 auto
      border-radius 20px
      width 580px
      .photo-box
        display flex
      .title
        font-size 24px
        color #073D7D
        margin-bottom 18px
      .input-style
        width 100%
        margin-bottom 20px
      .avatar-uploader
        width auto
      .ant-upload
        .ant-upload-select-picture-card
          background-color #fff
          border 1px solid #D5D5D5
      .ant-upload-text
        p
          font-size 12px
      .small-title
        font-size 14px
        color #000
        text-align left
      .ant-upload-text
        font-size 14px
        color #999
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #3281DD
        margin-bottom 18px
      .agree
        font-size 12px
        text-align left
</style>
